import { useCallback } from "react";

const DEFAULT_DOCUMENT_TITLE = "CCBox";
const DEFAULT_FAVICON_HREF = "/ccbox-mark.svg";

interface DocumentMetadataProps {
  faviconHref?: string | undefined;
  title: string;
}

export function DocumentMetadata({ faviconHref, title }: DocumentMetadataProps) {
  const applyMetadata = useCallback(
    (node: HTMLSpanElement | null) => {
      if (!node) return;
      const favicon = document.querySelector<HTMLLinkElement>("#ccbox-favicon");
      document.title = title;
      if (faviconHref && favicon) {
        favicon.href = faviconHref;
        favicon.removeAttribute("type");
      } else if (favicon) {
        favicon.href = DEFAULT_FAVICON_HREF;
        favicon.type = "image/svg+xml";
      }

      return () => {
        document.title = DEFAULT_DOCUMENT_TITLE;
        if (favicon) {
          favicon.href = DEFAULT_FAVICON_HREF;
          favicon.type = "image/svg+xml";
        }
      };
    },
    [faviconHref, title],
  );

  return <span hidden ref={applyMetadata} />;
}
